import Sentry from "@similarweb/sentry-logger";

import { TEAMS } from "app/constants/teamName";

const BASE_URL = "/api/nt-account-device-notifications";

export const fetchShouldShowModal = async () => {
    try {
        const response = await fetch(`${BASE_URL}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const data = await response.json();
        return data.length !== 0;
    } catch (error) {
        Sentry.errorTracker({
            message: "UsersAddOnModal: error on fetchShouldShowModal",
            e: error,
            level: "error",
            params: {
                tags: { team: TEAMS.LYNX },
            },
        });
        return false;
    }
};

export const postUpdateShowModal = async () => {
    try {
        await fetch(`${BASE_URL}/update-user-notified`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        });
    } catch (error) {
        Sentry.errorTracker({
            message: "UsersAddOnModal: error on postUpdateShowModal",
            e: error,
            level: "error",
            params: {
                tags: { team: TEAMS.LYNX },
            },
        });
    }
};
